import React from "react";
import ReactDOM from "react-dom/client";
import "./tailwind.css"; // Import Tailwind CSS

import "./index.css";
import MainRouter from "./MainRouter";
import reportWebVitals from "./reportWebVitals";
import { LanguageProvider } from "./i18n/LanguageContext";
import "./index.css"; // Your custom styles

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <LanguageProvider>
      <MainRouter />
    </LanguageProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
